import React, { useEffect, useState } from "react";
import { format, formatDistance } from "date-fns";
import TextTruncate from '../../../../utilsComponent/textTruncate';
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import InvestigationRequest from "./InvestigationRequest";
import { editModeOn, formatDocumentDetails} from "../../../../utilFunctions";
import { DATE_FORMAT, functionalities, INVESTIGATION_TYPES, RISK } from "../../../../consts";
import CloseInvestigationForm from "./CloseInvestigationForm";
import NoDataFound from "../../../../utilsComponent/noDataFound";
import DocumentSliderModal from "../../../../utilsComponent/DocumentSliderModal";
import "../Investigation/investigation.scss";
import { addInvestigationRemarks, triggerStatus} from "./investigationHelper";
import RemarksAndDocumentsModal from "./RemarksAndDocumentsModal";
import { getIsShowButton } from "../Service/apiHelper";

const InvestigationDetails = ({
  investigationLists,
  loading,
  claimDetails,
  roleDataCookie,
  setNotified,
  activeTab
}) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({
    investigation: null,
    actionType: "", // "add" or "close"
  });
  const [showRemarksModal, setShowRemarksModal] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [allDocuments, setAllDocuments] =useState([])
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [showDocumentModal, setShowDocumentModal] = useState(false);
  const [currentDocIndex, setCurrentDocIndex] = useState(0);
  const [activeIndex, setActiveIndex] = useState();
  const [investigationTitle, setInvestigationTitle] =useState('');
  const [showUpdatedRemarks,setShowUpdatedRemarks] = useState(false);
  const [startingInvestigation, setStartingInvestigation] = useState(false);

const handleOpenCloseModal = (investigation, actionType) => {
  setShowModal(false); // Close the modal first

  // Use a short delay via a state effect or callback to reopen
  requestAnimationFrame(() => {
    setModalData({ investigation, actionType });
    setShowModal(true);
  });
};

useEffect(() => {
  if (activeTab !== "INVESTIGATION") {
    setActiveIndex(undefined);
    setSelectedRemarks([]);
    setAllDocuments([]);
    setShowRemarksModal(false);
    setInvestigationTitle("");
  }
}, [activeTab]);


const handleStartInvestigation = async (investigationId) => {
  setStartingInvestigation(true)
  try {
    const investigationInitiatedBy = roleDataCookie?.userID
    const investigationType = INVESTIGATION_TYPES.GENERAL;
    const claimId= claimDetails?.claimId

    const response = await triggerStatus({
      investigationId,
      investigationInitiatedBy,
      investigationType,
      claimId
    });

    if (response?.Status === "Success") {
      setNotified(true);
    } else {
      console.warn("Investigation trigger failed:", response);
    }
  } catch (error) {
    console.error("Error starting investigation:", error);
  } finally {
    setStartingInvestigation(false);
  }
};

  const closeModal = () => {
    setShowModal(false);
  };

const handleViewRemarksAndDocuments = async (investigation, index) => {
  try {
    const remarksData = await addInvestigationRemarks(investigation.investigationId);
    const formattedDocs = formatDocumentDetails(remarksData.documentDetails);
    const isActive = activeIndex === index;

    setSelectedRemarks(isActive ? [] : remarksData?.remarks || []);
    setAllDocuments(isActive ? [] : formattedDocs);
    setShowRemarksModal(!isActive);
    setInvestigationTitle(isActive ? `` : `Investigation Review - ${investigation.investigationId}`);
    setActiveIndex(isActive ? undefined : index);
  } catch (error) {
    console.error("Failed to fetch remarks:", error);
  } finally {
    setLoadingRequest(false);
    closeModal();
  }
};

  const handleViewReport = async (investigation) => {
    try {
      const remarksData = await addInvestigationRemarks(investigation?.investigationId)

    if (remarksData?.documentDetails?.length > 0) {
      const formattedDocs = formatDocumentDetails(remarksData.documentDetails); 

      setSelectedDocuments(formattedDocs);
      setCurrentDocIndex(0);
      setShowDocumentModal(true);
    } else {
      console.warn("No documents found in remarksData.");
    }
  } catch (error) {
    console.error("Failed to fetch remarks:", error);
  }
};
   useEffect(() => {   
     if(showUpdatedRemarks) {
       if(showRemarksModal) {
         handleViewRemarksAndDocuments(modalData?.investigation, activeIndex);
       }
       setShowUpdatedRemarks(false);
     }
   },[showUpdatedRemarks])

  return (
    <>
      <div className="d-flex align-items-end justify-content-between">
        <h3 className="heading_h2History ms-3 mt-4" id="historyHistory">
          Investigation Records
        </h3>

        {editModeOn(functionalities.INVESTIGATION_TAB) && claimDetails?.status?.toLowerCase() !== "close" && getIsShowButton(claimDetails?.subStatus) &&  (
          <InvestigationRequest
            id={claimDetails?.claimId}
            setNotified={setNotified}
            claimDetails={claimDetails}
            modalData={modalData}
            investigationLists={investigationLists}
            roleDataCookie={roleDataCookie}
          />
        )}
      </div>

      <div className="row">
        <section className="p-4 pt-0 table-responsive">
          {loading ? (
            <LoadingPage kshemaLoader/>
          ) : investigationLists && investigationLists.length !== 0 ? (
            <div className="overflowGIS scrollbar">
              <table id="claim_historyField">
                <thead>
                  <tr className="sticky-header">
                    <th>Investigation Id</th>
                    <th>Requested By</th>
                    <th>Requested Date & Time</th>
                    <th>Trigger for Investigation</th>
                    <th>Reason for Investigation</th>
                    <th>Investigation Initiated By</th>
                    <th>Investigation Initiated Date & Time</th>
                    <th>Investigation Completed Date & Times</th>
                    <th>Aging</th>
                    <th>Status</th>
                    <th>Closing Remarks</th>
                    <th>Report</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {investigationLists.map((investigation, index) => (
                    <tr key={index}>
                      <td className="centerField">
                       <span
                            className="text-primary pointer"
                            onClick={() => {
                              handleViewRemarksAndDocuments(investigation, index);
                            }}
                          >{investigation.investigationId || "--"}</span>
                      </td>
                      <td className="centerField">
                         <span>{investigation?.investigationRequestedBy || '---'}</span>
                      </td>
                      <td className="centerField">
                      <span>
                            {investigation.investigationRequestedDate
                              ? format(new Date(investigation.investigationRequestedDate),  DATE_FORMAT.DD_MM_YYYY_HH_MM)
                              : "--"}
                        </span>
                      </td>
                      <td className="centerField">
                       <TextTruncate text={investigation.triggeredReason || "--"} length={30} />  
                      </td>
                      <td className="centerField">
                        <TextTruncate text={investigation.reasonForInvestigation || "--"} length={30} />
                      </td>
                      <td className="centerField">
                        <span>{investigation.investigationStatus  !== 'Open' ? (investigation.investigationInitiatedBy || "--"): "--"}</span>
                      </td>
                      <td className="centerField">
                        {investigation.investigationInitiatedDate
                              ? format(new Date(investigation.investigationInitiatedDate), DATE_FORMAT.DD_MM_YYYY_HH_MM)
                              : "--"}
                      </td>
                      <td className="centerField">
                        {investigation.investigationCompletedDate
                              ? format(new Date(investigation.investigationCompletedDate),  DATE_FORMAT.DD_MM_YYYY_HH_MM)
                              : "--"}
                      </td>
                      <td className="centerField">
                        {investigation.investigationRequestedDate
                              ? formatDistance(
                                  new Date(investigation.investigationRequestedDate),
                                  investigation?.investigationCompletedDate ? new Date(investigation.investigationCompletedDate) : new Date()
                                )
                              : "--"}
                      </td> 
                     {/* Status */}
                      <td className="centerField d-flex flex-column align-items-start">
                          <span>{investigation.investigationStatus || "--"}</span>
                          {(roleDataCookie?.roleName == "Admin" || (editModeOn(functionalities.INVESTIGATION_TAB) && roleDataCookie?.roleName === RISK)) && investigation.investigationStatus === "In-Progress" && (
                            <span
                              className="text-primary text-decoration-underline mt-1 fs pointer"
                              onClick={() => handleOpenCloseModal(investigation, "add")}
                            >
                              + Remark
                            </span>
                           )}
                      </td>
                      <td className="centerField">
                        <TextTruncate
                          text={investigation.remarks ? (() => {
                            try {
                                 return (
                                      JSON.parse(investigation.remarks).find(r => r.status === "close")?.remarks || "--"
                                    );
                                } catch {
                                  return "--";
                                  }
                               })()
                            : "--"
                          }
                          length={30}
                        />
                      </td>
                      <td className="centerField">
                        <span
                        className="text-primary pointer"
                          onClick={(e) => {
                            e.preventDefault();
                            handleViewReport(investigation);
                          }}
                        >
                          View Report
                        </span>
                      </td>
                     <td className="centerField" style={{ }}>
                      {(roleDataCookie?.roleName == "Admin" || (editModeOn(functionalities.INVESTIGATION_TAB) && roleDataCookie?.roleName === RISK)) && investigation.investigationStatus  === 'Open' && (    
                         startingInvestigation ? (
                          <LoadingPage kshemaLoader />
                          ) : (
                          <span
                            className={`text-primary pointer ${startingInvestigation ? 'disabled text-muted' : ''}`}
                            onClick={(e) => {
                              e.preventDefault();
                              handleStartInvestigation(investigation.investigationId);
                            }}
                          >
                          Start Investigation /
                        </span>
                     ))}
                        <span
                          className={`text-primary pointer ${investigation.investigationStatus.toLowerCase() === 'closed' || !editModeOn(functionalities.INVESTIGATION_TAB) || !["Admin", RISK].includes(roleDataCookie?.roleName) ? 'disabled text-muted' : ''}`}
                          onClick={(e) => {
                            if((roleDataCookie?.roleName == "Admin" || (editModeOn(functionalities.INVESTIGATION_TAB) && roleDataCookie?.roleName === RISK)) && investigation.investigationStatus.toLowerCase() !== "closed") {
                            e.preventDefault();
                            handleOpenCloseModal(investigation, "close");
                          }}}
                        >
                          Close Investigation
                        </span> 
                    </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoDataFound text="No Data Found" />
          )}
        </section>
      </div>

      {/* Modal for Add/Close Investigation */}
      {showModal && (
        <div id="modal-overlay" className="text-start">
          <CloseInvestigationForm
            onClose={closeModal}
            modalData={modalData}
            claimDetails={claimDetails}
            roleDataCookie={roleDataCookie}
            setShowUpdatedRemarks={setShowUpdatedRemarks}
            setNotified={setNotified}
            heading={modalData.actionType === "add" ? "Add Remarks" : "Close Investigation"}
            loading={loadingRequest} // Pass the loading state as a prop
            onSubmit={handleViewRemarksAndDocuments} // Pass a new function to handle the submission
          />
        </div>
      )}
      {/* {investigationLists[activeIndex]?.remarks?.length > 0 && showRemarksModal && typeof activeIndex === 'number' && ( */}
      {/* Shared Modal for Remarks & Documents */}
      {showRemarksModal && (
      <RemarksAndDocumentsModal
        // show={showRemarksModal}
        // onClose={() => setShowRemarksModal(false)}
        remarks={selectedRemarks?.filter((remark) => {return remark?.status === 'add'})}
        closingRemarks={selectedRemarks?.filter((remark) => {return remark?.status === 'close'})}
        documents={allDocuments}
        title={investigationTitle}
        roleDataCookie= {roleDataCookie}
        onDocumentClick={(docs) => {
              setSelectedDocuments(docs)
              setCurrentDocIndex(0);
              setShowDocumentModal(true);
        }}
      />
      )}

      {/* Document Slider Modal */}
      {showDocumentModal && (
        <DocumentSliderModal
          show={showDocumentModal}
          onClose={() => setShowDocumentModal(false)}
          documents={selectedDocuments}
          currentIndex={currentDocIndex}
          setCurrentIndex={setCurrentDocIndex}
        />
      )}
    </>
  );
};

export default InvestigationDetails;
